<div class="col-md-12" style="margin-left: -125px">
    <div class="tab-pane" role="tabpanel" id="formulario25">
        <fieldset id="agregar_formulario25" class="">
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">
                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">(S.M.P.E.- 5.1.17)</span> Formulario 2.5
                                <span style="float: right; clear: right;">1/5</span>
                            </div>
                            <h1><strong>SOLICITUD DE MODIFICACI&Oacute;N DE PROYECTO DE EDIFICACI&Oacute;N</strong></h1>
                            <br />
                            <div class="col-md-1"></div>
                            <div class="col-md-10">
                                <table class="title">
                                    <tr>

                                        <td class="col-md-3">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].obra" name="obra" id="obra" />
                                            <label class="titleBox" for="optradio"> OBRA NUEVA</label>
                                        </td>
                                        <td class="col-md-4 letraChica">
                                            <label class="titleBox" for="optradio">LOTEO DFL CON INSTRUCCION SIMULTANEA</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_dfl == 'SI'" name="loteo_dfl" id="loteo_dfl" />
                                            <label class="titleBox" for="loteo_dfl"> SI</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_dfl == 'NO'" name="loteo_dfl" id="loteo_dfl" />
                                            <label class="titleBox" for="loteo_dfl"> NO</label>
                                        </td>
                                        <td class="col-md-3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td class="col-md-3"></td>
                                        <td class="col-md-4 letraChica">
                                            <label class="titleBox" for="optradio">LOTEO DFL CON CONSTRUCCION SIMULTANEA</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_const == 'SI'" name="loteo_const" id="loteo_const" />
                                            <label class="titleBox" for="loteo_const"> SI</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_const == 'NO'" name="loteo_const" id="loteo_const" />
                                            <label class="titleBox" for="loteo_const"> NO</label>
                                        </td>
                                        <td class="col-md-3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-1"></div>
                            <table>
                                <tr>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].ampliacion" name="optradio2" id="optradio" />
                                        <label class="titleBox" for="optradio"> AMPLIACI&Oacute;N MAYOR A 100 M2</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].alteracion" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> ALTERACI&Oacute;N</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].reparacion" name="optradio1" id="optradio" />
                                        <label class="titleBox" for="optradio"> REPARACI&Oacute;N</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].reconstruccion" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> RECONSTRUCCI&Oacute;N</label>
                                    </td>
                                </tr>
                            </table>
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br>
                            <div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr>
                                        <td class="fondoResaltado" align="left" rowspan="2">
                                            SINGULARIZACI&Oacute;N PERMISO PRIMITIVO
                                        </td>
                                        <td class="fondoResaltado">
                                            N&Uacute;MERO
                                        </td>
                                        <td class="fondoResaltado">
                                            DE FECHA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="s_permiso_primitivo[0].cert_permiso" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="s_permiso_primitivo[0].fecha_permiso" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado" align="left" rowspan="2">
                                            CERTIFICADO DE INFORMACIONES PREVIAS
                                        </td>
                                        <td class="fondoResaltado">
                                            N&Uacute;MERO
                                        </td>
                                        <td class="fondoResaltado">
                                            DE FECHA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="cip[0].certcip" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="cip[0].fecha_cip" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.- DECLARACION JURADA</span>
                                    <span class="help-block"></span>
                                </div>

                                <table style="width: 100%;" class="tablaConBordeExterno table">
                                    <tr>
                                        <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>

                                    </tr>
                                    <tr>
                                        <td align="left"><span>IDENTIDAD Nº</span></td>
                                        <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                        <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span> SER</span></td>
                                        <td align="left"><span>PROPIETARIO</span></td>
                                        <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                        <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                        <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                        <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                        <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                        <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                        <td align="left"> <span>DE LA COMUNA DE </span></td>
                                        <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" [(ngModel)]="propietarios[0].comuna" type="text" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                        <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                        <td align="center"><span>N°</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                        <td align="center"><span>AÑO</span></td>
                                        <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                        <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left">DE PROPIEDAD</td>
                                        <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                        <td align="left"> DE BIENES </td>
                                        <td align="left"> RAÍCES DE</td>
                                        <td align="left" colspan="6"><input disabled class="form-control" id="bienes" name="bienes" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                    </tr>
                                    <tr>
                                        <td align="left">EN EL CUAL</td>
                                        <td align="left">SE EMPLAZA</td>
                                        <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                        <td align="left"><span>PARA EL QUE SE</span></td>
                                        <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>

                                    </tr>

                                </table>
                                <table class="tablaConBorde table">
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 40%;" align="left"><span>ADJUNTA PLANO TOPOGRAFICO (*)</span><span class="letraChica"> ART 1.4.8 OGUC</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'SI'"/>SI</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/>NO</span></td>
                                        <td colspan="2" class="fondoResaltado" style="width: 50%; " align="left"><span></span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DENOMINADO: </span></td>
                                        <td colspan="5"><span><input disabled class="form-control" id="denominado" name="denominado" type="text" [(ngModel)]="declaracion[0].denominado"/></span></td>

                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>ELABORADO</span></td>
                                        <td colspan="3"><span><input disabled class="form-control" id="elaborado" name="elaborado" type="text" [(ngModel)]="declaracion[0].elaborado"/></span></td>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DE PROFESION</span></td>
                                        <td><span><input disabled class="form-control" id="profesion" name="profesion" type="text" [(ngModel)]="declaracion[0].profesion" /></span></td>
                                    </tr>
                                </table>

                                <div class="letraChica"><span>NOTA: DE EXISTIR DOS O MÁS PROPIETARIOS, Y/O DOS O MÁS BIENES RAÍCES SE DEBERÁ ACOMPAÑAR HOJA ADJUNTA CON LOS DATOS Y FIRMAS CORRESPONDIENTE (*) SOLO EN LA EVENTUALIDAD QUE SE ACOMPAÑE DICHO PLANO.</span></div>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>3.- DATOS DEL PROPIETARIO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE DEL PROPIETARIO
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7">

                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%" align="left">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado" align="left">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4" align="left">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>4.- ARQUITECTO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left"><span>
                                            NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td style="width: 15%">
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 65%">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                        </td>
                                        <td rowspan="5" style="width: 15%"></td>

                                    </tr>
                                    <tr class=" fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE ARQUITECTO RESPONSABLE
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 30%" class="fondoResaltado">
                                            N°
                                        </td>
                                        <td style="width: 20%" class="fondoResaltado">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                        </td>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            E-MAIL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%">
                                            TEL&Eacute;FONO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FAX
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                                <span class="letraChica">NOTA: DE HABER MAS DE UN PROFESIONAL RESPONSABLE, ADJUNTAR DOCUMENTO CON FORMATO SIMILAR AL ANTERIOR QUE CONTENGA LOS DATOS NECESARIOS.</span>
                            </div>
                            <br />
                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">(S.M.P.E - 5.1.17)</span> Formulario 2.5
                                <span style="float: right; clear: right;">2/5</span>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>5.- PROFESIONALES QUE INTERVIENEN EN LA MODIFICACI&Oacute;N DE PROYECTO</span>
                                    <span class="help-block"></span>
                                </div>
                                <div>
                                    <table class="tablaConBorde table form-group clone1">
                                        <tr class="fondoResaltado">
                                            <td style="width: 80%" align="left">
                                                NOMBRE O RAZ&Oacute;N SOCIAL de la Empresa del <strong>ARQUITECTO</strong> (cuando corresponda)
                                            </td>
                                            <td colspan="2">
                                                R.U.T.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="arq_emp_nombre" name="arq_emp_nombre" type="text" [(ngModel)]="empresas[0].nombre" />
                                            </td>
                                            <td colspan="2">
                                                <input disabled class="form-control" id="arq_emp_rut" name="arq_emp_rut" type="text" [(ngModel)]="empresas[0].rut" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left">
                                                NOMBRE DEL <strong>ARQUITECTO</strong>
                                            </td>
                                            <td colspan="2">
                                                R.U.T.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="arq_nombre" name="arq_nombre" type="text" [(ngModel)]="arquitectos[0].nombre" />
                                            </td>
                                            <td colspan="2">
                                                <input disabled class="form-control" id="arq_nombre" name="arq_nombre" type="text" [(ngModel)]="arquitectos[0].rut" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left">
                                                NOMBRE DEL <strong>CALCULISTA</strong>
                                            </td>
                                            <td colspan="2">
                                                R.U.T.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="calc_nombre" name="calc_nombre" type="text" [(ngModel)]="calculistas[0].nombre" />
                                            </td>
                                            <td colspan="2">
                                                <input disabled class="form-control" id="calc_rut" name="calc_rut" type="text" [(ngModel)]="arquitectos[0].rut" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left">
                                                NOMBRE DEL <strong>CONSTRUCTOR</strong>
                                            </td>
                                            <td colspan="2">
                                                R.U.T.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="cons_nombre" name="cons_nombre" type="text" [(ngModel)]="constructores[0].nombre" />
                                            </td>
                                            <td colspan="2">
                                                <input disabled class="form-control" id="cons_rut" name="cons_rut" type="text" [(ngModel)]="constructores[0].rut" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left">
                                                NOMBRE del <strong>REVISOR INDEPENDIENTE</strong> (cuando corresponda)
                                            </td>
                                            <td>
                                                REGISTRO
                                            </td>
                                            <td>
                                                CATEGORIA
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="rep_nombre" name="rep_nombre" type="text" [(ngModel)]="independiente[0].nombre" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rep_reg" name="rep_reg" type="text" [(ngModel)]="independiente[0].registro" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rep_cat" name="rep_cat" type="text" [(ngModel)]="independiente[0].categoria" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left">
                                                NOMBRE O RAZ&Oacute;N SOCIAL del
                                                <Strong>REVISOR DEL PROYECTO DE CALCULO ESTRUCTURAL</Strong> (cuando corresponda)
                                            </td>
                                            <td>
                                                REGISTRO
                                            </td>
                                            <td>
                                                CATEGORIA
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="rev_est_nombre" name="rev_est_nombre" type="text" [(ngModel)]="revisor[0].nombre" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rev_est_reg" name="rev_est_reg" type="text" [(ngModel)]="revisor[0].registro" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rev_est_cat" name="patrev_est_cat_arq" type="text" [(ngModel)]="revisor[0].categoria" />
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td align="left">
                                                NOMBRE <strong>PROFESIONAL COMPETENTE</strong> (cuando corresponda)
                                            </td>
                                            <td>
                                                REGISTRO
                                            </td>
                                            <td>
                                                CATEGORIA
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" id="rev_est_pro" name="rev_est_pro" type="text" placeholder="por definir" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rev_est_reg" name="rev_est_reg" type="text" placeholder="por definir" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" id="rev_est_cat" name="rev_est_cat" type="text" placeholder="por definir" />
                                            </td>
                                        </tr>
                                        <br>
                                        <tr>
                                            <td class="fondoResaltado" align="left" style="text-align: left">
                                                ADJUNTA COMUNICACI&Oacute;N DEL PROPIETARIO EN QUE SEÑALE EL CAMBIO DE PROFESIONALES
                                            </td>
                                            <td>
                                                <span style="padding-left: 20px"><input type="checkbox" disabled class="form-check-inline" readonly id="" name="cambio_profesional" value="SI" [checked]="cambio_profesional[0].cambio_profesional == 'SI'" /> SI</span>
                                            </td>
                                            <td>
                                                <span style="padding-left: 20px"><input type="checkbox" disabled class="form-check-inline" readonly id="" name="cambio_profesional" value="NO" [checked]="cambio_profesional[0].cambio_profesional == 'NO'" /> NO</span>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                                <br />
                                <div class="tituloSeccion">
                                    <span>6.- PARTICIPACI&Oacute;N DE REVISORES</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td style="width: 50%" class="fondoResaltado izquierda"><span>
                                                    CUENTA CON INFORME FAVORABLE DE REVISOR INDEPENDIENTE</span>
                                        </td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="SI" [checked]="informe[0].infradio == 'SI'" /><span>SI</span></td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="NO" [checked]="informe[0].infradio == 'NO'" /><span>NO</span></td>
                                        <td style="width: 7%" class="fondoResaltado"><span>N°</span></td>
                                        <td style="width: 10%">
                                            <span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="informe[0].num_informe" *ngIf="informe[0].infradio == 'SI'" /></span>
                                            <span><input disabled class="form-control" readonly id="numero" name="numero" type="text" *ngIf="informe[0].infradio == 'false'" /></span>
                                        </td>
                                        <td style="width: 9%" class="fondoResaltado"><span>Fecha</span></td>
                                        <td style="width: 10%">
                                            <span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="informe[0].fech_informe" *ngIf="informe[0].infradio == 'SI'"/></span>
                                            <span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" *ngIf="informe[0].infradio == 'false'"/></span>
                                        </td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde2 table form-group">
                                    <tr>
                                        <td class="fondoResaltado izquierda" colspan="3" style="width: 70%">
                                            NOMBRE DEL REVISOR INDEPENDIENTE
                                        </td>
                                        <td class="fondoResaltado" style="width: 10%">
                                            R.U.T.
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FIRMA REVISOR
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" [(ngModel)]="independiente[0].nombre" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" [(ngModel)]="independiente[0].rut" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                        <td rowspan="5"></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="fondoResaltado izquierda">
                                            DIRECCI&Oacute;N/ CALLE/ PASAJE
                                        </td>
                                        <td class="fondoResaltado">
                                            Nº
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="independiente[0].direccion_completa" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="independiente[0].direccion_completa" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 40%">EMAIL</td>
                                        <td>TELEFONO / FAX</td>
                                        <td>CATEGORIA</td>
                                        <td>REGISTRO</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" [(ngModel)]="independiente[0].mail" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" [(ngModel)]="independiente[0].fono" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" [(ngModel)]="independiente[0].categoria" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" [(ngModel)]="independiente[0].registro" *ngIf="informe[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" *ngIf="informe[0].infradio == 'NO'" />
                                        </td>
                                    </tr>
                                </table>
                                <br />

                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td style="width: 50%" class="fondoResaltado izquierda"><span>
                                                    CUENTA CON INFORME DE REVISOR DE C&Aacute;LCULO ESTRUCTURA</span>
                                        </td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="SI" [checked]="informe_revisor[0].infradio == 'SI'" /><span>SI</span></td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="NO" [checked]="informe_revisor[0].infradio == 'NO'" /><span>NO</span></td>
                                        <td style="width: 7%" class="fondoResaltado"><span>N°</span></td>
                                        <td style="width: 10%">
                                            <span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="informe_revisor[0].num_informe" *ngIf="informe_revisor[0].infradio == 'SI'"/></span>
                                            <span><input disabled class="form-control" readonly id="numero" name="numero" type="text" *ngIf="informe_revisor[0].infradio == 'NO'"/></span>
                                        </td>
                                        <td style="width: 9%" class="fondoResaltado"><span>Fecha</span></td>
                                        <td style="width: 10%">
                                            <span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="informe_revisor[0].fecha_informe" *ngIf="informe_revisor[0].infradio == 'SI'"/></span>
                                            <span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" *ngIf="informe_revisor[0].infradio == 'NO'"/></span>
                                        </td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde2 table form-group">
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 40%">
                                            NOMBRE O RAZ&Oacute;N SOCIAL REVISOR DE C&Aacute;LCULO ESTRUCTURAL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%" colspan="2">
                                            PROFESIONAL COMPETENTE
                                        </td>
                                        <td class="fondoResaltado" style="width: 10%">
                                            R.U.T.
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FIRMA CALCULISTA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" *ngIf="informe_revisor[0].infradio == 'SI'" [(ngModel)]="independiente[0].nombre" />
                                            <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" [(ngModel)]="independiente[0].rut" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" [(ngModel)]="independiente[0].rut" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                        <td rowspan="5"></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" colspan="3">
                                            DIRECCI&Oacute;N/ CALLE/ PASAJE
                                        </td>
                                        <td class="fondoResaltado">
                                            Nº
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="independiente[0].direccion_completa" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="independiente[0].direccion_completa" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="direccion" name="direccion" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 40%">EMAIL</td>
                                        <td>TELEFONO / FAX</td>
                                        <td>CATEGORIA</td>
                                        <td>REGISTRO</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" [(ngModel)]="independiente[0].mail" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" [(ngModel)]="independiente[0].fono" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" [(ngModel)]="independiente[0].registro" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" [(ngModel)]="independiente[0].categoria" *ngIf="informe_revisor[0].infradio == 'SI'" />
                                            <input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" *ngIf="informe_revisor[0].infradio == 'NO'" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="tituloSeccion">
                                <span>7.- CARACTER&Iacute;STICAS DEL PROYECTO MODIFICADO</span>
                                <span class="letraChica">  (QUE ACOMPAÑAN LA PRESENTE SOLICITUD)</span>
                                <span class="help-block"></span>
                            </div>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.1.- DESTINO (S) CONTEMPLADO(S) DE LA PARTE QUE SE MODIFICA</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado" style="width: 49%">
                                        CAMBIO DE DESTINO RESPECTO DEL PERMISO OTORGADO
                                    </td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="cambio_destino" id="cambio_destino"  [checked]="cambio_destino[0].cambio_destino == 'SI'"/>SI</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="cambio_destino" id="cambio_destino"  [checked]="cambio_destino[0].cambio_destino == 'NO'"/>NO</span></td>
                                    <td style="width: 40%">

                                    </td>
                                </tr>
                            </table>
                            <table class="tablaConBorde2 table form-group">
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="" name="residencial" value="SI" [checked]="destino[0].residencial" /></td>
                                    <td align="left">
                                        <span>RESIDENCIAL</span><br>
                                        <span>Art. 2.1.25.OGUC.</span>
                                    </td>
                                    <td>
                                        DESTINO ESPECIFICO
                                    </td>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="destino_resd" name="destino_resd" type="text" [(ngModel)]="destino[0].destino_resd" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white" rowspan="2">
                                        <input type="checkbox" disabled class="form-check-inline" readonly id="equipamiento" name="equipamiento" value="SI" [checked]="destino[0].equipamiento" />
                                    </td>
                                    <td align="left" rowspan="2">
                                        <span>Equipamiento</span><br>
                                        <span>Art. 2.1.33.OGUC.</span>
                                    </td>
                                    <td>
                                        Clase Art.2.1.33 OGUC.
                                    </td>
                                    <td>
                                        Actividad
                                    </td>
                                    <td>
                                        Escala Art.2.1.36. OGUC.
                                    </td>
                                </tr>
                                <tr>

                                    <td>
                                        <input disabled class="form-control" readonly id="clase_eq" name="clase_eq" type="text" [(ngModel)]="destino[0].clase_eq" />
                                    </td>

                                    <td>
                                        <input disabled class="form-control" readonly id="actividad_eq" name="actividad_eq" type="text" [(ngModel)]="destino[0].actividad_eq" />
                                    </td>

                                    <td>
                                        <input disabled class="form-control" readonly id="total1" name="escala_eq" type="text" [(ngModel)]="destino[0].escala_eq" />
                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="actividad" name="actividad" value="SI" [checked]="destino[0].actividad" /></td>
                                    <td align="left">
                                        <span>ACTIVIDADES PRODUCTIVOS</span><br>
                                        <span>Art. 2.1.28.OGUC.</span>
                                    </td>
                                    <td>
                                        DESTINO ESPECIFICO
                                    </td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="destino_act" name="destino_act" type="text" [(ngModel)]="destino[0].destino_act" /></td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="infraestructura" name="infraestructura" value="SI" [checked]="destino[0].infraestructura" /></td>
                                    <td align="left">
                                        <span>INFRAESTRUCTURA</span><br>
                                        <span>Art. 2.1.29.OGUC.</span>
                                    </td>
                                    <td>
                                        DESTINO ESPECIFICO
                                    </td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="destino[0].destino_infr" /></td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="otros" name="otros" value="SI" [checked]="destino[0].otros" /></td>
                                    <td align="left">
                                        <span>OTROS</span><br>
                                    </td>
                                    <td>
                                        (especificar)
                                    </td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="esp_otros" name="esp_otros" type="text" [(ngModel)]="destino[0].esp_otros" /></td>
                                </tr>
                            </table>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.2- SUPERFICIES</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td rowspan="2">

                                    </td>
                                    <td colspan="2">
                                        UTIL (m2)
                                    </td>
                                    <td colspan="2">
                                        COM&Uacute;N (m2)
                                    </td>
                                    <td rowspan="2">
                                        TOTAL (m2)
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        P.PRIMITIVO
                                    </td>
                                    <td>
                                        A.MODIFICAR
                                    </td>
                                    <td>
                                        P.PRIMITIVO
                                    </td>
                                    <td>
                                        A.MODIFICAR
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        S. EDIFICADA BAJO TERRENO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util1prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util1comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="comun1" name="comun1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun1prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun1comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="total1" name="total1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].total1" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        S. EDIFICADA SOBRE TERRENO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util2prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util2comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun2prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun2comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].total2" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        S. EDIFICACI&Oacute;N TOTAL
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util3prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util3comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun3prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun3comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].total3" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado izquierda">
                                    <td colspan="5">
                                        SUPERFICIE TOTAL TERRENO (m2)
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="totalt" name="totalt" type="text" [(ngModel)]="superficie_proyecto_modificado[0].totalt" />
                                    </td>
                                </tr>
                            </table>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.3- DISPOSICIONES GENERALES APLICADAS INCLUIDA LA PARTE QUE SE MODIFICA</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado" colspan="4" align="left" style="text-align: left">
                                        SE ACOGE A NUEVAS NORMAS (Art.5.1.18. O.G.U.C.)
                                    </td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="nuevas_normas"  [checked]="nuevas_normas[0].nuevas_normas == 'SI'"/>SI</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="nuevas_normas"  [checked]="nuevas_normas[0].nuevas_normas == 'NO'"/>NO</span></td>
                                </tr>
                                <br>
                                <tr class="fondoResaltado">
                                    <td>

                                    </td>
                                    <td style="width: 10%">
                                        PERMITIDO
                                    </td>
                                    <td style="width: 10%">
                                        PROYECTADO
                                    </td>
                                    <td>

                                    </td>
                                    <td style="width: 10%">
                                        PERMITIDO
                                    </td>
                                    <td style="width: 10%">
                                        PROYECTADO
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        COEFICIENTE DE CONSTRUCTIBILIDAD
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="constr_perm" name="constr_perm" type="text" [(ngModel)]="normas_urbanisticas[0].constr_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="constr_proy" name="constr_proy" type="text" [(ngModel)]="normas_urbanisticas[0].constr_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        COEF. DE OCUPACI&Oacute;N DE SUELO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="suelo_perm" name="suelo_perm" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="suelo_proy" name="suelo_proy" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        COEF.DE OCUPACI&Oacute; PISOS<br> SUPERIORES
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="ocup_perm" name="ocup_perm" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="ocup_proy" name="ocup_proy" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        DENSIDAD
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="densid_perm" name="densid_perm" type="text" [(ngModel)]="normas_urbanisticas[0].densid_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="densid_proy" name="densid_proy" type="text" [(ngModel)]="normas_urbanisticas[0].densid_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        ALTURA MAXIMA EN METRO o PISOS
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="alt_perm" name="alt_perm" type="text" [(ngModel)]="normas_urbanisticas[0].alt_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="alt_proy" name="alt_proy" type="text" [(ngModel)]="normas_urbanisticas[0].alt_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ADOSAMIENTO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="adosam_perm" name="adosam_perm" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="adosam_proy" name="adosam_proy" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        RASANTE
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="rasant_perm" name="rasant_perm" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="rasant_proy" name="rasant_proy" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ANTEJARDIN
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="antej_perm" name="antej_perm" type="text" [(ngModel)]="normas_urbanisticas[0].antej_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="antej_proy" name="antej_proy" type="text" [(ngModel)]="normas_urbanisticas[0].antej_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        DISTANCIAMIENTO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="dist_perm" name="dist_perm" type="text" [(ngModel)]="normas_urbanisticas[0].dist_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="dist_proy" name="dist_proy" type="text" [(ngModel)]="normas_urbanisticas[0].dist_proy" />
                                    </td>
                                </tr>
                                <br>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        ESTACIONAMIENTOS REQUERIDOS
                                    </td>
                                    <td colspan="2" style="width: 20%;">
                                        <input disabled class="form-control" readonly id="est_req" name="est_req" type="text" [(ngModel)]="normas_urbanisticas[0].est_req" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ESTACIONAMIENTOS PROYECTO
                                    </td>
                                    <td colspan="2" style="width: 20%">
                                        <input disabled class="form-control" readonly id="est_proy" name="est_proy" type="text" [(ngModel)]="normas_urbanisticas[0].est_proy" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.M.P.E.- 5.1.17.)</span> <span>Formulario 2.5</span>
                                <span style="float: right; clear: right;">3/5</span>
                            </div>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.4- CLASIFICACI&Oacute;N(ES) CONSTRUCCI&Oacute;N(ES) PREDOMINANTE(S)</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td>
                                        CLASIFICACI&Oacute;N
                                    </td>
                                    <td>
                                        m2
                                    </td>
                                    <td>
                                        CLASIFICACI&Oacute;N
                                    </td>
                                    <td>
                                        m2
                                    </td>
                                </tr>
                                <tr class="fondoResaltado0">
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" [(ngModel)]="clasificacion[0].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" [(ngModel)]="clasificacion[0].metro" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].metro" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado0">
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].metro" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].metro" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado0">
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].metro" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].metro" />
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="6">
                                        DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="disposiciones_esp" id="disposiciones_esp" [checked]="disposiciones_esp[0].disposicion1" /></td>
                                    <td>
                                        D.F.L-Nº2 de 1959
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="disposiciones_esp" id="disposiciones_esp" [checked]="disposiciones_esp[0].disposicion3" /></td>
                                    <td>
                                        Proyecci&oacute;n Sombras Art. 2.6.11 OGUC
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="disposiciones_esp" id="disposiciones_esp" [checked]="disposiciones_esp[0].disposicion4" /></td>
                                    <td>
                                        Segunda Vivienda Art. 6.2.4. OGUC
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="disposiciones_esp" id="disposiciones_esp" [checked]="disposiciones_esp[0].disposicion5" /></td>
                                    <td>
                                        Conjunto Arm&oacute;nico Art. 2.6.4. OGUC
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="disposiciones_esp" id="disposiciones_esp" [checked]="disposiciones_esp[0].disposicion6" /></td>
                                    <td>
                                        Beneficio Fusi&oacute;n Art. 63 LGUC
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="disposiciones_esp" id="disposiciones_esp" [checked]="disposiciones_esp[0].disposicion2" /></td>
                                    <td>
                                        Ley Nº 19.537 Copropiedad Inmobiliaria
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="disposiciones_esp" id="disposiciones_esp" [checked]="disposiciones_esp[0].disposicion7" /></td>
                                    <td>
                                        Conj. Viv. Econ. Art. 6.1.8 OGUC
                                    </td>
                                </tr>
                            </table>
                            <table class="tablaConBorde2 table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="5">
                                        AUTORIZACIONES ESPECIALES LGUC
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="autorizaciones" id="autorizaciones"  [checked]="autorizaciones[0].Art121"/> Art. 121</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="autorizaciones" id="autorizaciones"  [checked]="autorizaciones[0].Art122"/> Art. 122</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="autorizaciones" id="autorizaciones"  [checked]="autorizaciones[0].Art123"/> Art. 123</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="autorizaciones" id="autorizaciones"  [checked]="autorizaciones[0].Art124"/> Art. 124</span></td>
                                    <td style="width: 21%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="autorizaciones" id="autorizaciones"  [checked]="autorizaciones[0].Otro"/> Otro (especificar)</span></td>
                                </tr>
                            </table>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado izquierda" style="width:  70%">
                                        EDIFICIOS DE USO PUBLICO
                                    </td>
                                    <td align="center" style="background: white; width: 12%">
                                        <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'todo'" /> TODO</span>
                                    </td>
                                    <td align="center" style="background: white; width: 12%">
                                        <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'parte'" /> PARTE</span>
                                    </td>
                                    <td align="center" style="background: white; width: 6%">
                                        <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'no'" /> NO</span>
                                    </td>
                                </tr>
                            </table>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.5- N&Uacute;MERO DE UNIDADES TOTALES POR DESTINO INCLUIDA LA PARTE QUE SE MODIFICA</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td class="fondoResaltado izquierda">
                                        VIVIENDASS
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="vivienda" name="vivienda" type="text" [(ngModel)]="unidades[0].vivienda" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        OFICINAS
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="oficinas" name="oficinas" type="text" [(ngModel)]="unidades[0].oficinas" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td class="fondoResaltado izquierda">
                                        LOCALES COMERCIALES
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="locales" name="locales" type="text" [(ngModel)]="unidades[0].locales" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ESTACIONAMIENTOS
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="estacionamientos" name="estacionamientos" type="text" [(ngModel)]="unidades[0].estacionamientos" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td class="fondoResaltado izquierda">
                                        OTROS (ESPECIFICAR)
                                    </td>
                                    <td colspan="3" align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="unidades[0].otros" />
                                    </td>
                                </tr>
                            </table>

                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td>
                                        <input disabled class="form-control" readonly id="clase_eq" name="clase_eq" type="text" [(ngModel)]="destino[0].clase_eq" />
                                    </td>

                                    <td>
                                        <input disabled class="form-control" readonly id="actividad_eq" name="actividad_eq" type="text" [(ngModel)]="destino[0].actividad_eq" />
                                    </td>

                                    <td>
                                        <input disabled class="form-control" readonly id="total1" name="escala_eq" type="text" [(ngModel)]="destino[0].escala_eq" />
                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="actividad" name="actividad" value="SI" [checked]="destino[0].actividad" /></td>
                                    <td align="left">
                                        <span>ACTIVIDADES PRODUCTIVOS</span><br>
                                        <span>Art. 2.1.28.OGUC.</span>
                                    </td>
                                    <td>
                                        DESTINO ESPECIFICO
                                    </td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="destino_act" name="destino_act" type="text" [(ngModel)]="destino[0].destino_act" /></td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="infraestructura" name="infraestructura" value="SI" [checked]="destino[0].infraestructura" /></td>
                                    <td align="left">
                                        <span>INFRAESTRUCTURA</span><br>
                                        <span>Art. 2.1.29.OGUC.</span>
                                    </td>
                                    <td>
                                        DESTINO ESPECIFICO
                                    </td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="destino[0].destino_infr" /></td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="otros" name="otros" value="SI" [checked]="destino[0].otros" /></td>
                                    <td align="left">
                                        <span>OTROS</span><br>
                                    </td>
                                    <td>
                                        (especificar)
                                    </td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="esp_otros" name="esp_otros" type="text" [(ngModel)]="destino[0].esp_otros" /></td>
                                </tr>
                            </table>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.2- SUPERFICIES</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td rowspan="2">

                                    </td>
                                    <td colspan="2">
                                        UTIL (m2)
                                    </td>
                                    <td colspan="2">
                                        COM&Uacute;N (m2)
                                    </td>
                                    <td rowspan="2">
                                        TOTAL (m2)
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        P.PRIMITIVO
                                    </td>
                                    <td>
                                        A.MODIFICAR
                                    </td>
                                    <td>
                                        P.PRIMITIVO
                                    </td>
                                    <td>
                                        A.MODIFICAR
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        S. EDIFICADA BAJO TERRENO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util1prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util1comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="comun1" name="comun1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun1prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun1comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="total1" name="total1" type="text" [(ngModel)]="superficie_proyecto_modificado[0].total1" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        S. EDIFICADA SOBRE TERRENO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util2prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util2comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun2prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun2comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].total2" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        S. EDIFICACI&Oacute;N TOTAL
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util3prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].util3comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun3prim" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].comun3comun" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_proyecto_modificado[0].total3" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado izquierda">
                                    <td colspan="5">
                                        SUPERFICIE TOTAL TERRENO (m2)
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="totalt" name="totalt" type="text" [(ngModel)]="superficie_proyecto_modificado[0].totalt" />
                                    </td>
                                </tr>
                            </table>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.3- DISPOSICIONES GENERALES APLICADAS INCLUIDA LA PARTE QUE SE MODIFICA</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado" colspan="4" align="left" style="text-align: left">
                                        SE ACOGE A NUEVAS NORMAS (Art.5.1.18. O.G.U.C.)
                                    </td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/>SI</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/>NO</span></td>
                                </tr>
                                <br>
                                <tr class="fondoResaltado">
                                    <td>

                                    </td>
                                    <td style="width: 10%">
                                        PERMITIDO
                                    </td>
                                    <td style="width: 10%">
                                        PROYECTADO
                                    </td>
                                    <td>

                                    </td>
                                    <td style="width: 10%">
                                        PERMITIDO
                                    </td>
                                    <td style="width: 10%">
                                        PROYECTADO
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        COEFICIENTE DE CONSTRUCTIBILIDAD
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="constr_perm" name="constr_perm" type="text" [(ngModel)]="normas_urbanisticas[0].constr_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="constr_proy" name="constr_proy" type="text" [(ngModel)]="normas_urbanisticas[0].constr_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        COEF. DE OCUPACI&Oacute;N DE SUELO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="suelo_perm" name="suelo_perm" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="suelo_proy" name="suelo_proy" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        COEF.DE OCUPACI&Oacute; PISOS<br> SUPERIORES
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="ocup_perm" name="ocup_perm" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="ocup_proy" name="ocup_proy" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        DENSIDAD
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="densid_perm" name="densid_perm" type="text" [(ngModel)]="normas_urbanisticas[0].densid_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="densid_proy" name="densid_proy" type="text" [(ngModel)]="normas_urbanisticas[0].densid_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        ALTURA MAXIMA EN METRO o PISOS
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="alt_perm" name="alt_perm" type="text" [(ngModel)]="normas_urbanisticas[0].alt_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="alt_proy" name="alt_proy" type="text" [(ngModel)]="normas_urbanisticas[0].alt_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ADOSAMIENTO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="adosam_perm" name="adosam_perm" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="adosam_proy" name="adosam_proy" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        RASANTE
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="rasant_perm" name="rasant_perm" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="rasant_proy" name="rasant_proy" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_proy" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ANTEJARDIN
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="antej_perm" name="antej_perm" type="text" [(ngModel)]="normas_urbanisticas[0].antej_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="antej_proy" name="antej_proy" type="text" [(ngModel)]="normas_urbanisticas[0].antej_proy" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        DISTANCIAMIENTO
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="dist_perm" name="dist_perm" type="text" [(ngModel)]="normas_urbanisticas[0].dist_perm" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" readonly id="dist_proy" name="dist_proy" type="text" [(ngModel)]="normas_urbanisticas[0].dist_proy" />
                                    </td>
                                </tr>
                                <br>
                                <tr>
                                    <td class="fondoResaltado izquierda">
                                        ESTACIONAMIENTOS REQUERIDOS
                                    </td>
                                    <td colspan="2" style="width: 20%;">
                                        <input disabled class="form-control" readonly id="est_req" name="est_req" type="text" [(ngModel)]="normas_urbanisticas[0].est_req" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ESTACIONAMIENTOS PROYECTO
                                    </td>
                                    <td colspan="2" style="width: 20%">
                                        <input disabled class="form-control" readonly id="est_proy" name="est_proy" type="text" [(ngModel)]="normas_urbanisticas[0].est_proy" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.M.P.E.- 5.1.17.)</span> <span>Formulario 2.5</span>
                                <span style="float: right; clear: right;">3/5</span>
                            </div>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.4- CLASIFICACI&Oacute;N(ES) CONSTRUCCI&Oacute;N(ES) PREDOMINANTE(S)</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td>
                                        CLASIFICACI&Oacute;N
                                    </td>
                                    <td>
                                        m2
                                    </td>
                                    <td>
                                        CLASIFICACI&Oacute;N
                                    </td>
                                    <td>
                                        m2
                                    </td>
                                </tr>
                                <tr class="fondoResaltado0">
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" [(ngModel)]="clasificacion[0].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" [(ngModel)]="clasificacion[0].metro" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].metro" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado0">
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].metro" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].metro" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado0">
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].metro" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                        <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].clasificacion" />
                                    </td>
                                    <td style="max-width: 281px; min-width: 281px;">
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                        <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].metro" />
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="6">
                                        DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano" [checked]="declaracion[0].plano == 'NO'" /></td>
                                    <td>
                                        D.F.L-Nº2 de 1959
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano" [checked]="declaracion[0].plano == 'NO'" /></td>
                                    <td>
                                        Proyecci&oacute;n Sombras Art. 2.6.11 OGUC
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano" [checked]="declaracion[0].plano == 'NO'" /></td>
                                    <td>
                                        Segunda Vivienda Art. 6.2.4. OGUC
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano" [checked]="declaracion[0].plano == 'NO'" /></td>
                                    <td>
                                        Conjunto Arm&oacute;nico Art. 2.6.4. OGUC
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano" [checked]="declaracion[0].plano == 'NO'" /></td>
                                    <td>
                                        Beneficio Fusi&oacute;n Art. 63 LGUC
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano" [checked]="declaracion[0].plano == 'NO'" /></td>
                                    <td>
                                        Ley Nº 19.537 Copropiedad Inmobiliaria
                                    </td>
                                    <td style="width: 5%; " align="center"><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano" [checked]="declaracion[0].plano == 'NO'" /></td>
                                    <td>
                                        Conj. Viv. Econ. Art. 6.1.8 OGUC
                                    </td>
                                </tr>
                            </table>
                            <table class="tablaConBorde2 table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="5">
                                        AUTORIZACIONES ESPECIALES LGUC
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/> Art. 121</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/> Art. 122</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/> Art. 123</span></td>
                                    <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/> Art. 124</span></td>
                                    <td style="width: 21%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/> Otro (especificar)</span></td>
                                </tr>
                            </table>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado izquierda" style="width:  70%">
                                        EDIFICIOS DE USO PUBLICO
                                    </td>
                                    <td align="center" style="background: white; width: 12%">
                                        <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'todo'" /> TODO</span>
                                    </td>
                                    <td align="center" style="background: white; width: 12%">
                                        <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'parte'" /> PARTE</span>
                                    </td>
                                    <td align="center" style="background: white; width: 6%">
                                        <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="uso_publico[0].uso_publico == 'no'" /> NO</span>
                                    </td>
                                </tr>
                            </table>
                            <div class="tituloSeccion">
                                <span class="help-block letraChica">7.5- N&Uacute;MERO DE UNIDADES TOTALES POR DESTINO INCLUIDA LA PARTE QUE SE MODIFICA</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td class="fondoResaltado izquierda">
                                        VIVIENDASS
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="vivienda" name="vivienda" type="text" [(ngModel)]="unidades[0].vivienda" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        OFICINAS
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="oficinas" name="oficinas" type="text" [(ngModel)]="unidades[0].oficinas" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td class="fondoResaltado izquierda">
                                        LOCALES COMERCIALES
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="locales" name="locales" type="text" [(ngModel)]="unidades[0].locales" />
                                    </td>
                                    <td class="fondoResaltado izquierda">
                                        ESTACIONAMIENTOS
                                    </td>
                                    <td align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="estacionamientos" name="estacionamientos" type="text" [(ngModel)]="unidades[0].estacionamientos" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td class="fondoResaltado izquierda">
                                        OTROS (ESPECIFICAR)
                                    </td>
                                    <td colspan="3" align="left" style="background: white">
                                        <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="unidades[0].otros" />
                                    </td>
                                </tr>
                            </table>

                            <div class="col-md-12" style="padding-left: 0px; padding-right: 0px">
                                <div class="col-md-12 tituloSeccion" style="padding-left: 0px">
                                    <span>8.- ANTECEDENTES QUE SE ADJUNTAN </span><span class="letraChica">(ART.5.1.17. O.G.U.C)</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="2" align="center">EDIFICACIONES</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled></td>
                                        <td><span>Listado de antecedentes y Planes Numerados que se agregan reemplazan o eliminan</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Fotocopia del Certificado de informaciones Previas</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Lista de modificaciones, referidas a cada plano, firmada por el arquitecto</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Planos con las modificaciones indicando cambios respecto del proyecto original firmados por el arquitecto y el propietario</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Formulario &uacute;nico de estad&iacute;sticas de edificaci&oacute;n, cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Informe del Revisor Independiente, cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Especificaciones T&eacute;cnicas, de las modificaciones, si corresponde, firmados por el arquitecto y propietario</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Presupuesto de las obras complementarias si las hubiere</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Estudio de ascensores, cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Patente al d&iacute;a de Profesionales Competentes</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Fotocopia de c&aacute;lculo estructural si corresponde</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                        <td><span>Informe del Revisor del Proyecto de C&aacute;lculo estructural, cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Cuadro de superficies, individualizando &aacute;reas que se modifican las que se amplian o disminuyen</span></td>
                                    </tr>

                                </table>
                                <span class="letraChica" align="left">DEBERA ACOMPAÑARSE AL MOMENTO DE LA SOLICITUD, UNA COPIA DE LOS DOCUMENTOS Y PLANOS</span>


                            </div>

                            <br />
                            <br>
                            <div>
                                <div class="tituloSeccion">
                                    <span>9.- MONTO A CONSIGNAR AL INGRESO</span>
                                    <span class="letraChica">(A LLENAR POR LA D.O.M.)</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="4" rowspan=6 style="width: 63%">
                                            CLASIFICACI&Oacute;N (ES) DE LA CONSTRUCCI&Oacute;N
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>

                                            Clasificaci&oacute;n
                                        </td>
                                        <td>
                                            m2
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            PRESUPUESTO
                                        </td>
                                        <td colspan="2">
                                            <input disabled value="$" class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            TOTAL DERECHOS MUNICIPALES
                                        </td>
                                        <td class="fondoResaltado" align="right" style="width: 3%">
                                            %
                                        </td>
                                        <td colspan="2">
                                            <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            DESCUENTO 30% CON INFORME DE REVISOR INDEPENDIENTE (*)
                                        </td>
                                        <td class="fondoResaltado" align="right" style="width: 3%">
                                            (-)
                                        </td>
                                        <td colspan="2">
                                            <input disabled value="$" class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            MONTO A CONSIGNAR AL INGRESO DE LA PRESENTE SOLICITUD
                                        </td>
                                        <td class="fondoResaltado" align="right" style="width: 3%">
                                            %
                                        </td>
                                        <td colspan="2">
                                            <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde2 table form-group">
                                    <tr>
                                        <td style="width: 58%">
                                            GIRO INGRESO MUNICIPAL
                                        </td>
                                        <td class="fondoResaltado" align="right" style="width: 3%">
                                            Nº
                                        </td>
                                        <td style="width: 14%">
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                        <td class="fondoResaltado" style="width: 7%">
                                            Fecha
                                        </td>
                                        <td style="width: 15%">
                                            <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <br />
                            <br>
                            <br>

                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado" colspan="2" style="height: 20px;">
                                        <strong>LISTADO DE PLANOS QUE SE REEMPLAZAN, SE AGREGAN O ELIMINAN</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="height: 20px; width: 15%" align="center">
                                        PLANO Nº
                                    </td>
                                    <td align="tablaConBordeExterno">
                                        CONTENIDO
                                    </td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style="height: 20px;"></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                        <div id='page4' class="contenedorFormulario print-wrap page4">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.M.P.E.- 5.1.17.)</span> <span>Formulario 2.5</span>
                                <span style="float: right; clear: right;">4/5</span>
                            </div>
                            <br>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado">
                                        <strong>LISTADO DE DOCUMENTOS QUE SE REEMPLAZAN, SE AGREGAN O SE ELIMINAN</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <span class="letraChica"> <strong>NOTA</strong>: Solo para situaciones especiales del permiso</span>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td>
                                        <br>
                                        <br>
                                        <br>
                                        <br>

                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>

                                    </td>
                                </tr>
                            </table>

                        </div>
                        <br>
                        <br>
                        <br>
                        <br>
                        <div id='page5' class="contenedorFormulario print-wrap page5">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.M.P.E.- 5.1.17.)</span> <span>Formulario 2.5</span>
                                <span style="float: right; clear: right;">5/5</span>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <hr>
                            <div class="col-md-3"></div>
                            <div style="padding-left: 72px" class="col-md-6">
                                <h1><strong>COMPROBANTE DE INGRESO</strong></h1>

                            </div>
                            <div class="col-md-12 tituloSeccion" align="center">
                                <span>SOLICITUD DE MODIFICACI&Oacute;N DE PROYECTO DE EDIFICACI&Oacute;N</span>
                                <span class="help-block"></span>
                            </div>

                            <br>
                            <br />
                            <br />
                            <div>
                                <table class="tablaConBorde izquierda">
                                    <tr>
                                        <td class="fondoResaltado">MONTO CONSIGNADO AL INGRESO</td>
                                        <td><input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                        <td class="fondoResaltado">GIM N°</td>
                                        <td><input disabled class="form-control" readonly id="gim" name="gim" type="text" /></td>
                                        <td class="fondoResaltado">FECHA</td>
                                        <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-3">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>

                                    </table>

                                </div>
                                <br />
                                <div class="col-md-1"></div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 64%;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado" style="width: 20%">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td style="width: 80%">CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />

                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" align="left">
                <button mat-raised-button color="primary"  id="pdf-download-link" title="Descargar Formulario 2.5" (click)="captureScreen()">Descargar Formulario 2.5</button>
            </div>
        </fieldset>
    </div>
</div>